export const SEARCH_NOTIFICATION_STREAMS = 'SEARCH_NOTIFICATION_STREAMS';

export const createNotificationStreamsAction =
  ({ filterName, data }) =>
  dispatch => {
    dispatch({
      type: SEARCH_NOTIFICATION_STREAMS,
      payload: { filterName, data },
    });
  };
